import { isDefined } from "@clipboard-health/util-ts";
import { Alert, type AlertColor } from "@mui/material";
import { type ReactNode } from "react";

/**
 * @deprecated Use the Banner component from cbh-mobile-app's redesign system (ui-components has been removed from cbh-core).
 */
export interface BannerProps {
  children: ReactNode;
  severity: AlertColor;
  onClose?: () => void;
}

/**
 * @deprecated Use `Banner` from cbh-mobile-app's redesign system instead.
 */
export function Banner(props: BannerProps) {
  const { children, severity, onClose } = props;

  return (
    <Alert
      severity={severity}
      icon={false}
      sx={{
        borderRadius: 0,
        width: "100%",
        "& .MuiAlert-message": { width: "100%", textAlign: "center" },
      }}
      variant="filled"
      {...(isDefined(onClose) && { onClose })}
    >
      {children}
    </Alert>
  );
}
